<template>
  <div>
    <div class="d-flex justify-content ml-2 align-items-center my-2">
      <button class="btn btn-sm rounded-circle p-25 cursor-pointer" @click="goBack()">
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div
        class="ml-1 text-capitalize text-dark cursor-pointer goback-text"
        @click="goBack()"
      >
        Regresar
      </div>
    </div>
    <div v-if="isLoaded" class="container d-flex justify-content-end">
      <div v-if="$can('viewDocument', 'MaintenanceForm')">
        <button
          class="btn btn-sm btn-primary mr-2"
          @click="previewDocument(formId)"
        >
          <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50 text-capitalize">
              {{ $t("actions.view_document") }}
            </span>
        </button>
      </div>

      <div v-if="$can('downloadDocument', 'MaintenanceForm')">
        <button
          v-if="pdfGenerated"
          :disabled="btnDownloadDocument"
          class="btn btn-sm btn-primary"
          @click="downloadDocument(formId)"
        >
          <feather-icon
            v-if="!btnDownloadDocument"
            icon="DownloadIcon"
          />

          <b-spinner v-else small type="grow"></b-spinner>
          <span class="align-middle ml-50 text-capitalize">
            {{ $t("actions.download_document") }}
          </span>
        </button>
      </div>
    </div>
    <build-form v-if="formId" :form-id="formId" @submit="onSubmit" @validated="handleValidate" @loaded="handleLoaded"/>

    <template>
      <div v-if="isView" class="modal-overlay">
        <div class="modal-content">
          <!--<b-button @click="closeModal" class="close-button">X</b-button>-->
          <div v-if="isLoading" class="loading-container">
            <b-spinner variant="primary" :label="$t('messages.loading.title')"></b-spinner>
            <p class="mt-2">{{ $t("messages.loading.document") }}</p>
          </div>
          <iframe
            v-if="itemView"
            :src="itemView"
            width="100%"
            height="600px"
            @load="onPdfLoad"
            @error="onPdfError"
            style="border: none;"
            v-show="!isLoading"
          ></iframe>
          <div v-if="itemView" class="d-flex justify-content-end gap-2 mt-3">
            <b-button
              size="sm"
              variant="secondary"
              class="text-capitalize mr-1"
              @click="cancelPdf(formId)"
              :disabled="!btnSave"
            >
              {{ $t("actions.cancel") }}
            </b-button>
            <b-button
              v-if="btnSaveShow"
              variant="info"
              size="sm"
              class="text-capitalize"
              @click="savePdf(formId)"
              :disabled="!btnSave"
            >
              <feather-icon
                v-if="btnSave"
                icon="SaveIcon"
              />

              <b-spinner v-else small type="grow"></b-spinner>
              {{ $t("actions.save") }}
            </b-button>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import BuildForm from "@/components/BuildForm";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: { BuildForm },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      schema: [],
      formValues: {},
      formId: null,
      templateId: null,
      serviceOrder: null,
      isValidating: false,

      isLoaded: false,
      isView: false,
      itemView: null,
      isLoading: false,
      pdfBlobUrl: null,
      btnDownloadDocument: false,
      btnSave: false,
      btnSaveShow: true,
      pdfGenerated: false,
    };
  },
  async mounted() {
    if (this.$route.params.id_form) {
      this.formId = this.$route.params.id_form;
      await this.fetchFormData();
    }
  },
  methods: {
    async fetchFormData() {
      try {
        const { data } = await axios.get(`/v1/maintenance-forms/${this.formId}`);
        if (data && data.service_order) {
          this.serviceOrder = data.service_order;
          this.pdfGenerated = data.pdf_generated;
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    },
    async handleValidate(serviceOrderId) {
      // Use serviceOrderId from event if provided, otherwise use local serviceOrder
      const orderId = serviceOrderId || (this.serviceOrder && this.serviceOrder.id);

      if (!orderId) {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "No se pudo obtener la orden de servicio",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      this.isValidating = true;
      try {
        await this.$store.dispatch("service_orders/editStatus", {
          id: orderId,
          params: {
            id_status: 4,
          },
        });

        this.toast({
          component: ToastificationContent,
          props: {
            title: this.$t("messages.edit_save.updated_successfully"),
            icon: "CheckIcon",
            variant: "success",
          },
        });

        // Refresh form data to update status
        await this.fetchFormData();
      } catch (error) {
        console.error("Error validating form:", error);
        this.toast({
          component: ToastificationContent,
          props: {
            title:
              error.response?.data?.message ||
              this.$t("messages.errors.generic_error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.isValidating = false;
      }
    },
    goBack() {
      this.$router.push({ name: "service_orders" });
    },
    onSubmit() {
      console.log("OK");
      // Refresh form data after submit
      this.fetchFormData();
    },
    handleLoaded(status) {
      this.isLoaded = status;
    },
    async previewDocument(formId) {
      this.isLoading = true;
      this.isView = true;
      this.itemView = null;

      if (this.pdfBlobUrl) {
        window.URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfBlobUrl = null;
      }

      try {
        const response = await axios.get(`/v1/maintenance-forms/download_document/${formId}`, {
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        });

        if (response.data instanceof Blob) {
          const url = window.URL.createObjectURL(response.data);
          this.pdfBlobUrl = url;
          this.itemView = url;
          this.btnSave = true

        } else {
          throw new Error("La respuesta no es un blob válido");
        }
      } catch (error) {
        this.isLoading = false;
        this.isView = false;
        this.toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || this.$t("messages.errors.loading_document"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    onPdfLoad(){
      this.isLoading = false;
    },
    onPdfError(){
      this.isLoading = false;
      this.toast({
        component: ToastificationContent,
        props: {
          title: this.$t("messages.errors.showing_document"),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    closeModal(){
      this.isView = false;
      this.isLoading = false;
      if (this.pdfBlobUrl) {
        window.URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfBlobUrl = null;
      }
      this.itemView = null;
    },
    async savePdf(formId) {
      this.btnSave = false
      try {
        const response = await axios.post(`/v1/maintenance-forms/save-document/${formId}`);
        if(response.data.success){
          this.pdfGenerated = true
          this.btnSaveShow = false
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'PDF guardado correctamente',
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.closeModal()
        }
        return true

      } catch (error) {
        console.log(error)
      }
    },
    async cancelPdf(formId){
      this.closeModal();
      try {
        const response = await axios.post(`/v1/maintenance-forms/cancel-document/${formId}`);
        return true

      } catch (error) {
        console.log(error)
      }
    },
    async downloadDocument(formId) {
      this.btnDownloadDocument = true;

      try {
        const response = await axios.get(`/v1/maintenance-forms/download-store-document/${formId}`, {
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        });

        if (response.data instanceof Blob) {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.download = `documento_${formId}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          throw new Error("La respuesta no es un blob válido");
        }

      } catch (error) {
        this.toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || this.$t("messages.errors.loading_document"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.btnDownloadDocument = false;
      }
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 1000px;
  border-radius: 8px;
  position: relative;
  min-height: 600px;
  max-height: 90vh;
  overflow: auto;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background-color: #ff4d4d;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
  z-index: 1001;
}

.close-button:hover {
  background-color: #ff1a1a;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
}
</style>
